const ACTIONS = ["show_skills", "show_neurons"];
export function buildWorldModelRecommendationContext({currentPortal="root",currentMesh=null,currentPhase=null}={}) {
  return {currentPortal,currentMesh,currentPhase};
}
export async function requestWorldModelRecommendations() {
  return {selectedActions:ACTIONS,source:"local"};
}
export async function recordWorldModelRecommendationSelection() { return null; }
